import Typography from "../../../models/typography";
import { APP_ELEMENTS_AND_CLASS, FONT_STYLES } from "../constants";

const defaultAppFont: Typography[] = [
  {
    element: APP_ELEMENTS_AND_CLASS.BODY.value,
    src: "https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap",
    fontFamily: "Nunito",
    fontWeight: "400",
    style: FONT_STYLES.NORMAL,
  },
  {
    element: APP_ELEMENTS_AND_CLASS.HEADLINE.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: '800',
    style: FONT_STYLES.NORMAL,
    isCustomTag: true
  },
  {
    element: APP_ELEMENTS_AND_CLASS.H1.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: '600',
    style: FONT_STYLES.NORMAL
  },
  {
    element: APP_ELEMENTS_AND_CLASS.H2.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: '500',
    style: FONT_STYLES.NORMAL
  },
  {
    element: APP_ELEMENTS_AND_CLASS.H3.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: '500',
    style: FONT_STYLES.NORMAL
  },
  {
    element: APP_ELEMENTS_AND_CLASS.H4.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: '500',
    style: FONT_STYLES.NORMAL
  },
  {
    element: APP_ELEMENTS_AND_CLASS.H5.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: '500',
    style: FONT_STYLES.NORMAL
  },
  {
    element: APP_ELEMENTS_AND_CLASS.H6.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: '500',
    style: FONT_STYLES.NORMAL
  },
  {
    element: APP_ELEMENTS_AND_CLASS.CUSTOM_FONT.value,
    src: "/assets/fonts/satoshi/Satoshi-Variable.ttf",
    fontFamily: "satoshi",
    fontWeight: 'normal',
    style: FONT_STYLES.NORMAL,
    isCustomTag: true
  }
];

export default defaultAppFont;
